module.exports = __webpack_public_path__ + "vue_assets/img/img_emptystate_chest.c84d96ce.png";